const ROUTES = {
  LOGIN: '/login',
  OAUTH: '/oauth',
  REGISTER: '/register',
  CONFIRM_REGISTER: '/confirm-register',
  LANGUAGE_SELECT: '/language',
  CONFIRM_USER_DATA: '/confirm',
  PASSWORD_RESET: '/password-reset',
  ACCOUNT: '/user',
  ASSESSMENT: '/assessment',
  EXAMINATION: '/examination',
  EXAMINATION_RECEIVE: '/receive-examination',
  PUBLIC_EXAMINATION: '/public-examination',
} as const;

export type RoutesKeys = keyof typeof ROUTES;
export type RoutesValues = (typeof ROUTES)[RoutesKeys];

const HEADERLESS_PUBLIC_ROUTES = [
  ROUTES.LOGIN,
  ROUTES.REGISTER,
  ROUTES.PASSWORD_RESET,
  ROUTES.CONFIRM_REGISTER,
  ROUTES.EXAMINATION_RECEIVE,
  ROUTES.EXAMINATION,
  ROUTES.PUBLIC_EXAMINATION,
  ROUTES.OAUTH,
] as const;

export const isHeaderlessPublicRoute = (pathname: string) =>
  HEADERLESS_PUBLIC_ROUTES.some((route) => pathname.includes(route));

export default ROUTES;
